import { Redirect } from '#app/components/Redirect/index.js';

export const Page = () => {
  return (
    <Redirect
      method="replace"
      to="/opportunities"
    />
  );
};
